function save_postcode_cookie(x){

  var date = new Date();
  var m = 1/24; //minutes to expiry

  // console.log("cookies expiry = 1 / " + m);
  Cookies.set("fs_sugar_postcode",x, {expires :  m});

}

function clear_postcode_cookie(){
  var x = ""
  var date = new Date();
  var m = -1; //minutes to expiry

  date.setTime(date.getTime() + (m * 60 * 1000));
  // console.log("expiry date for cookies: " + date + "executed by clear_postcode_cookie()");

  $(function(){
    Cookies.remove("fs_sugar_postcode");
    //   console.log("clear_postcode_cookie() executedddd");
  }); 
};